<i18n>
{
  "fr": {
    "login-title": "Se connecter",
    "business-change-text": "Veuillez sélectionner l'entreprise à laquelle vous souhaitez accéder",

    "no-business-title": "Oups !",
    "no-business-message": "Vous n'êtes associé à aucune entreprise, veuillez contacter un administrateur.",

    "logout": "Se déconnecter"
  },
  "en": {
    "login-title": "Login",
    "business-change-text": "Please select the company you want to access",

    "no-business-title": "Oops !",
    "no-business-message": "You are not linked to any company, please contact an administrator.",
    "logout": "Logout"
  }
}
</i18n>

<template>
  <welcome>
    <div v-if="businessList.length > 1">
      <h1 class="title">{{ $t('login-title') }}</h1>
      <s-field :label="$t('business-change-text')" custom-class="has-text-weight-normal" label-for="selectedBusiness">
        <b-select id="selectedBusiness" @input="onSelectedBusiness" v-model="selectedBusiness" expanded>
          <option v-for="business in businessList" :key="business.id" :value="business.id">
            {{ business.name }}
          </option>
        </b-select>
      </s-field>
    </div>
    <div v-else-if="!loading && businessList.length === 0">
      <h1 class="title">{{ $t('no-business-title') }}</h1>
      <p>{{ $t('no-business-message') }}</p>
      <b-button @click="logout" class="mt-24px">{{ $t('logout') }}</b-button>
    </div>
  </welcome>
</template>

<script>
import AuthentificationService from '@/services/authentification'
import Welcome from '@/components/layout/welcome'
import SField from '@/components/form/field'
import BusinessService from '@/services/business'
import { URL_ROOT } from '@/consts/urls'

export default {
  components: {
    Welcome,
    SField
  },
  data() {
    return {
      loading: false,
      selectedBusiness: ''
    }
  },
  computed: {
    businessList: function () {
      if (!this.me) return []
      const list = this.me.business
      return list.slice().sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  methods: {
    onSelectedBusiness: async function (val) {
      let business = this.businessList.find((x) => {
        return x.id === val
      })
      await BusinessService.setCurrentBusinessData(business.id)
      let path = this.$router.currentRoute.query.returnPath || { name: URL_ROOT }
      this.$router.push(path)
    },
    logout: AuthentificationService.logout
  },
  apollo: {
    me: {
      query() {
        this.loading = true
        return this.$options.query.BusinessSelection_MyBusinesses
      },

      result(result) {
        if (result.loading) return
        if (result.data.me && result.data.me.business && result.data.me.business.length == 1) {
          this.onSelectedBusiness(result.data.me.business[0].id)
        }
        this.loading = false
      }
    }
  }
}
</script>

<graphql>
query BusinessSelection_MyBusinesses {
  me {
    id
    business {
      id
      name
    }
  }
}
</graphql>
